<template>
  <v-card>
    <v-card-title class="grey lighten-2" primary-title>{{ $t('components.PlanSettings.advancedPlanSettings') }}</v-card-title>
    <v-card-text>
      <v-tabs v-model="currentSettingsTab">
        <!-- If new settings are included, tabs displayed should be managed properly, based on which settings exist for the plan -->
        <v-tab>{{ $t('components.PlanSettings.minimumWeeklySpend') }} ({{ spendUnitName }})</v-tab>
      </v-tabs>
      <template v-if="currentSettingsTab === 0">
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-alert density="comfortable" type="info" text border="top" color="primary">
                {{ $t('components.PlanSettings.minSpendInfo') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" v-for="channel in channels" :key="`minWeeklySpend_${channel[0]}`">
              <v-text-field
                :label="`${prettyNames[channel[0]] ? prettyNames[channel[0]] : channel[0]}` + ` (${formatNumber(computedSettings.minWeeklySpend[channel[0]])})`"
                v-model="minWeeklySpend[channel[0]]"
                v-money="money"
                :rules="rules.minSpend">
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="gray lighten-2" text @click="dismissChanges">{{ $t('components.PlanSettings.cancel') }}</v-btn>
      <v-btn color="primary darken-1" text @click="saveChanges">{{ $t('components.PlanSettings.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import numbro from 'numbro'
import { VMoney } from 'v-money'
export default {
  data () {
    return {
      currentSettingsTab: 0,
      minWeeklySpend: {},
      money: {
        thousands: ',',
        precision: 0
      }
    }
  },
  computed: {
    rules () {
      return {
        minSpend: [
          v => (!!v && v[0] !== '-' && Number(this.removeNonDigits(v)) > 0) || this.$t('components.PlanSettings.positiveValueRequired')
        ]
      }
    }
  },
  methods: {
    dismissChanges () {
      this.$emit('save-settings', { minWeeklySpend: { ...this.settings.minWeeklySpend } })
      this.$emit('close-dialog')
    },
    saveChanges () {
      let minWeeklySpend = {}
      Object.entries(this.minWeeklySpend).forEach(item => {
        minWeeklySpend[item[0]] = Number(this.removeNonDigits(item[1]))
      })
      this.$emit('save-settings', { minWeeklySpend: { ...minWeeklySpend } })
      this.$emit('close-dialog')
    },
    removeNonDigits (str) {
      return str.toString().replace(/\D/g, '')
    },
    formatNumber: function (value) {
      return numbro(value).format({
        thousandSeparated: true
      })
    }
  },
  props: {
    channels: {
      type: Array,
      required: true
    },
    prettyNames: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    settings: {
      type: Object,
      required: true
    },
    computedSettings: {
      type: Object,
      required: true
    },
    spendUnitName: {
      type: String,
      required: true
    }
  },
  created () {
    this.minWeeklySpend = { ...this.settings.minWeeklySpend }
  },
  directives: {
    money: VMoney
  }
}
</script>
